import { useParams } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { apiRoot } from "../../index";
import "moment/locale/fr";

function PaidEstimateContent(props) {
  const params = useParams();
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(() => {
    setLoading(true);
    axios
      .get(apiRoot + "/api/v1/paid-estimate/" + params.uid + "/" + params.stripeSessionId)
      .then((res) => {
        setLoading(false);
        setInit(true);

        if (res.data) {
          window.location.href = "/sign-estimate/" + params.uid + "/" + res.data;
        } else {
          setError("Error on payment, try again");
        }
      });
  }, [params.stripeSessionId, params.uid]);

  // Init booking datas
  useEffect(() => {
    if (!init && !loading) fetchData();
  }, [init, loading, fetchData]);

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main"></div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label w-100 d-flex justify-content-between">
              <h3 className="kt-portlet__head-title">
                {loading && <>Loading...</>}
                {!loading && init && error && <>{error}</>}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaidEstimateContent;
